<template>
  <div class="home">
    <vue-headful title="ITT流体技术" description="ITT流体技术" />
    <div class="container">
      <div class="logo">
        <img src="@/assets/spxflow_logo_for_application2.png" alt="" />
      </div>
      <div id="list">
        <div class="item" v-for="(link, idx) in links" :key="idx" @click="gotoLink(link)">
          <div class="img">
            <img :src="'https://itt-ft.effective-wechat.com/storage/' + link.img" />
          </div>
          <h2>{{ link.name }}</h2>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getApplications } from "@/api/request";

export default {
  name: "home",
  data() {
    return {
      links: [],
    };
  },
  methods: {
    gotoLink(link) {
      this.$router.push(`/applications/${link.id}`);
      // location.href = link;
    },
  },
  async mounted() {
    Toast.loading({
      forbidClick: true,
      duration: 0,
    });

    let apps = await getApplications();
    this.links = apps.data;
    Toast.clear();
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  min-height: calc(100vh - 221px);
  .logo {
    width: 100vw;
    img {
      width: 100%;
      display: block;
    }
  }

  #list {
    font-family:
      Microsoft YaHei,
      Helvitica,
      Verdana,
      Tohoma,
      Arial,
      san-serif;

    .item {
      display: flex;
      position: relative;
      padding: 10px;
      border-bottom: 1px solid #ddd;

      div.img {
        flex: 1 0 20%;
        margin-right: 20px;
        height: 52px;
        img {
          height: 52px;
          border-radius: 3px;
        }
      }
      h2 {
        flex: 1 0 80%;
        font-size: 18px;
        align-self: center;
        color: #2f2f2f;
        font-weight: normal;
        text-overflow: ellipsis;
      }
      &::after {
        content: "";
        box-sizing: border-box;
        width: 0;
        height: 0;
        border-width: 20px 20px 0 0;
        border-style: solid;
        border-color: transparent #407cca transparent transparent;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
}
</style>
